module.exports = __webpack_public_path__ + "img/icon_language.7902f38.svg";